module.exports = __webpack_public_path__ + "media/fonts/icomoon-7c48ab01.eot";